import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import LoadObject from "data/LoadObject";
import { hotLoadObject } from "data/storeUtils";
import DevelopmentActions from "data/dev/DevelopmentActions";
import DevDataManager from "data/dev/DevDataManager";

class MocksetManifestStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return LoadObject.empty().withPropTypes({
            mocksets: PropTypes.arrayOf(
                PropTypes.string,
            ),
        });
    }

    reduce(state, action) {
        switch (action.type) {
            case DevelopmentActions.START_MOCKSET_MANIFEST_LOAD:
                return state.loading(DevDataManager.loadMocksetManifest());
            case DevelopmentActions.MOCKSET_MANIFEST_LOADED:
                return state.receiveValue({
                    mocksets: action.data
                        .split("\n")
                        .map(it => it.trim())
                        .filter(it => it.length > 0)
                });
            case DevelopmentActions.MOCKSET_MANIFEST_ERROR:
                return state.receiveError(action.error);
            default:
                return state;
        }
    }

    getLoadObject() {
        return hotLoadObject(
            () => this.getState(),
            () => Dispatcher.dispatch({
                type: DevelopmentActions.START_MOCKSET_MANIFEST_LOAD,
            }),
        );
    }
}

export default new MocksetManifestStore();



// WEBPACK FOOTER //
// ./app/data/dev/MocksetManifestStore.js